import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { api, formatApiErrorDetail } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, KeyRound, UserCircle } from "lucide-react";

export default function Profile() {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [busy, setBusy] = useState(false);

  const change = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success(t("profile.passwordChanged"));
      setCur(""); setNw("");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-lg space-y-6" data-testid="profile-page">
      <h1 className="font-heading text-3xl font-black text-slate-900">{t("profile.title")}</h1>

      <Card className="border-slate-200 bg-white p-5 shadow-sm">
        <div className="flex items-center gap-4">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-blue-100 text-blue-600"><UserCircle className="h-8 w-8" /></div>
          <div>
            <div className="font-heading text-lg font-bold text-slate-900">{user.name}</div>
            <div className="text-sm text-slate-500">{user.email}</div>
            <div className="overline mt-1 text-blue-600">{user.role_label}</div>
          </div>
        </div>
      </Card>

      <Card className="border-slate-200 bg-white p-5 shadow-sm">
        <div className="mb-4 flex items-center gap-2 text-slate-700"><KeyRound className="h-5 w-5 text-blue-600" /><span className="overline">{t("profile.changePassword")}</span></div>
        <form onSubmit={change} className="space-y-3">
          <div><Label className="overline text-slate-500">{t("profile.currentPassword")}</Label><Input data-testid="current-password" type="password" value={cur} onChange={(e) => setCur(e.target.value)} required className="mt-1.5 border-slate-300 bg-white" /></div>
          <div><Label className="overline text-slate-500">{t("profile.newPassword")}</Label><Input data-testid="new-password" type="password" value={nw} onChange={(e) => setNw(e.target.value)} required className="mt-1.5 border-slate-300 bg-white" /></div>
          <Button data-testid="change-password-submit" type="submit" disabled={busy || nw.length < 6} className="bg-blue-600 hover:bg-blue-500">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : t("profile.updatePassword")}
          </Button>
        </form>
      </Card>
    </div>
  );
}
